import { defineMessages } from '@transcend-io/internationalization';

export const networkErrorMessages = defineMessages(
  'privacy-center.components.NetworkError.networkError',
  {
    header: {
      defaultMessage: 'The Privacy Center failed to load.',
    },
    extension: {
      defaultMessage:
        'Something went wrong with our server. Try refreshing the page or coming back in a bit.',
    },
    contentBlockerMessage: {
      defaultMessage:
        'Your browser (or browser extension) prevented a connection to our server. The URL that was blocked is {Url}.' +
        ' If you have an ad blocker or content blocker enabled, please try disabling it and reloading this page.',
    },
    alt: {
      defaultMessage: 'Something went wrong.',
    },
  },
);
